import {
  SOCIALFEED_POST,
  SOCIALFEED_REACTION,
  SOCIALFEED_COMMENT,
  SOCIALFEED_MEDIA,
  SOCIALFEED_POLL,
  SOCIALFEED_ITEM_SELECTED,
  SOCIALFEED_TOUSERS_ENGAGE,
  SOCIALFEED_POSTYPES_PAICHART,
} from "SocialfeedActions";

export var SocialFeedMenu = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      key: SOCIALFEED_POST,
      iconName: "socialpost",
      sectionName: "Total Post",
      sectionDesc: "How many posts are made on the app's social feed",
      selected: false,
    },
    {
      key: SOCIALFEED_REACTION,
      iconName: "socialreaction",
      sectionName: "Reactions",
      sectionDesc: "Number of reaction on social feed posts",
      selected: false,
    },
    {
      key: SOCIALFEED_COMMENT,
      iconName: "socialcomments",
      sectionName: "Comments",
      sectionDesc: "Number of comments on social feed posts",
      selected: false,
    },
    {
      key: SOCIALFEED_MEDIA,
      iconName: "socialmedia",
      sectionName: "Media",
      sectionDesc: "Number of post having photos/videos",
      selected: false,
    },
    {
      key: SOCIALFEED_POLL,
      iconName: "socialpolls",
      sectionName: "Polls",
      sectionDesc:
        "No. of poll questions added to the social feed by the app users",
      selected: false,
    },
  ];

  var index = 0;
  state[index].selected = true;

  return state;
};

// Initial select tab is "SOCIALFEED_POST"
export var SocialfeedSelectedItem = (state = SOCIALFEED_POST, action) => {
  if (action.type == SOCIALFEED_ITEM_SELECTED) {
    state = action.payload.key;
  }

  return state;
};

// Local reducers for  Socialfeed Engagement {top users who were active on socialfeed app}
export var SocialfeedTousersEngagetablelist = (state = {}, action) => {
  switch (action.type) {
    case SOCIALFEED_TOUSERS_ENGAGE:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for Socialfeed Posting types [clacification for socialfeed post paichart]
export var SocialfeedPostypePaichartData = (state = {}, action) => {
  switch (action.type) {
    case SOCIALFEED_POSTYPES_PAICHART:
      return action.payload;
    default:
      return state;
  }
};
